export default {
  contact_us: "Contact us",
  credits: "© :YEAR :NAME. All rights reserved.",
  date_intervals: {
    different_day: ":start to :end",
    same_day: ":date from :start to :end",
  },
  designed_developed_by: "Designed and developed by <strong>Beet</strong>.",
  event: {
    future: "Upcoming Events",
    no_upcoming: "No upcoming events at the moment.",
    past: "Past Events",
    return: "Return to Events",
    see_all: "See all events",
  },
  links_to_consult: "Links to consult",
  navigation: {
    about: "About the Chair",
    activities: "Our Activities",
    careers: "Careers",
    research: "Our Research",
  },
  news: {
    return: "Return to News",
    see_all: "See all news",
  },
  not_found: {
    button: "Return to home",
    description:
      "<p>We can’t seem to find the page you’re looking for. Try exploring our site!</p>",
    title: "Oops, something got lost!",
  },
  page_titles: {
    home: "Home",
    about: "About",
    careers: "Careers",
    resources: "Resources",
    events: "Events",
    funding: "Funding",
    innovation: "Social Innovation",
    news: "News",
    posts: "Posts",
    policies: "Privacy Policy",
    projects: "Projects",
    team: "Team",
    not_found: "Page Not Found",
  },
  policies: {
    content: "<p>Content coming soon...</p>",
    title: "Privacy Policy",
  },
  read_more: "Read More",
  search: "Search",
  see_more: "See More",
  site_title: "Réseau de Proximité",
  view: "View",
};
